// extracted by mini-css-extract-plugin
export var errorsContainer = "_ve-1";
export var link = "_ve-0";